import styled from 'styled-components';

const IWGcardBackgroundColor = ({theme:{$iwgCardBackgroundColor}}) => `${$iwgCardBackgroundColor}`;
const IWGcardTextColor = ({theme:{$iwgCardTextColor}}) => `${$iwgCardTextColor}`;
const IWGimageBackgroundColor = ({theme:{$iwgImageBackgroundColor}}) => `${$iwgImageBackgroundColor}`;
const IWGimageFilterBackgroundColor = ({theme:{$iwgImageFilterBackgroundColor}}) => `${$iwgImageFilterBackgroundColor}`;

const S = {};

S.GameCard = styled.div`
    background-color: ${IWGcardBackgroundColor};
    position: relative;
    overflow: hidden;
    text-align: center;
    color: ${IWGcardTextColor};

    &:before {
        content: '';
        display: block;
        width: 100%;
        padding-top: 100%;
    }

    &.active {
        cursor: pointer;
    }
`

S.GameImage = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: ${IWGimageBackgroundColor};
    background-size: cover;
    background-position: center;
    transition: 0.5 ease;
    
    &:before {
        content: '';
        position: absolute;
        display: block;
        height: 100%;
        width: 100%;
        background-color: ${IWGimageFilterBackgroundColor};
        opacity: 0.4;
        &.active {
            opacity: 0;
        }
    }

    &:hover {
        transform: scale(1.1);
    }

    &.active {
        &:before {
            content: none;
        }
    }
`

S.CardName = styled.div`
    position: absolute;
    top: 0;
    box-sizing: border-box;
    width: 100%;
    padding: 10px;
    background-color: black;
    font-size: 13px;
    white-space: nowrap;
    text-overflow: ellipsis;
`



export default S;